import moment from "moment-timezone";

interface TimeFunctions {
  getTimeIntervalString: (time?: number) => string;
  parseTimeOffset: (offset: string) => number | undefined;
}

const getMinutes = (time: number): number => {
  const timeInSeconds = time / 1000;
  const hours = (timeInSeconds / 60 / 60) | 0;
  const minutes = (timeInSeconds - hours * 60 * 60) / 60;
  return minutes;
};

const getHours = (time: number): number => {
  const timeInSeconds = time / 1000;
  const hours = (timeInSeconds / 60 / 60) | 0;
  return hours;
};

export const useTime = (): TimeFunctions => {
  const getTimeIntervalString = (time?: number): string => {
    if (time !== undefined) {
      const momentDate = moment.tz("UTC").set({
        hour: getHours(time),
        minute: getMinutes(time),
        second: 0,
        millisecond: 0,
      });
      const hours = momentDate.hours();
      const minutes = momentDate.minutes();

      return `T${hours}H${minutes}M`;
    }
    return "";
  };

  const parseTimeOffset = (offset: string): number | undefined => {
    const parts = offset.split("T");
    if (parts[1] === undefined) {
      return undefined;
    }
    const times = parts[1].split("H");
    const parsedHours = Number(times[0].replace(/\D+/g, ""));
    const parsedMinutes = Number(times[1].replace(/\D+/g, ""));
    const momentDate = moment.tz("UTC").set({
      hour: parsedHours,
      minute: parsedMinutes,
      second: 0,
      millisecond: 0,
    });
    const hours = momentDate.hours();
    const minutes = momentDate.minutes();

    return (hours * 60 + minutes) * 60 * 1000;
  };

  return {
    getTimeIntervalString,
    parseTimeOffset,
  };
};
